export function index(jobId, type) {
    if (jobId) {
        jobId = '&filter[withInterimJob]=' + jobId;
    } else {
        jobId = '';
    }

    if (type) {
        type = '&filter[withType]=' + type;
    } else {
        type = '';
    }

    return axios.get(route('api.manage.companies.interims') + '?include=internalNotesCount,attachmentsCount,matrixValues.type,section' + jobId + type)
        .then(response => response.data);
}

export function show(interimId) {
    return axios.get(route('api.manage.interims.show', {interimId: interimId}) + '?include=internalNotes,attachments,interimJobs.job,internalNotesCount,attachmentsCount,matrixValues.type')
        .then(response => response.data);
}

export function store(data) {
    return axios.post(route('api.manage.companies.interims') + '?include=internalNotes,attachments,internalNotesCount,attachmentsCount,matrixValues.type', data)
        .then(response => response.data);
}

export function update(interimId, data) {
    return axios.patch(route('api.manage.interims.update', {interimId: interimId}) + '?include=internalNotes,attachments,internalNotesCount,attachmentsCount,matrixValues.type', data)
        .then(response => response.data);
}

export function destroy(interimId) {
    return axios.delete(route('api.manage.interims.destroy', {interimId: interimId}));
}

export function storeAttachment(interimId, data) {
    return axios.post(route('api.manage.interims.attachments.store', {interimId: interimId}) + '?include=internalNotes,attachments', data)
        .then(response => response.data);
}

export function destroyAttachment(interimId, attachmentId) {
    return axios.delete(route('api.manage.interims.attachments.destroy', {interimId, attachmentId}) + '?include=internalNotes,attachments')
        .then(response => response.data);
}

export function storeNote(interimId, data) {
    return axios.post(route('api.manage.interims.notes.store', {interimId: interimId}) + '?include=internalNotes,attachments', data)
        .then(response => response.data);
}

export function updateNote(interimId, noteId, data) {
    return axios.patch(route('api.manage.interims.notes.update', {interimId: interimId, noteId: noteId}) + '?include=internalNotes,attachments', data)
        .then(response => response.data);
}

export function destroyNote(interimId, noteId) {
    return axios.delete(route('api.manage.interims.notes.destroy', {interimId, noteId}) + '?include=internalNotes,attachments')
        .then(response => response.data);
}

export function destroyConnection(interimId, data) {
    return axios.delete(route('api.manage.interims.connection.destroy', {interimId: interimId}))
        .then(response => response.data);
}

export function refreshConnection(interimId, data) {
    return axios.patch(route('api.manage.interims.connection.refresh', {interimId: interimId}))
        .then(response => response.data);
}
